var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-10 system-message"},[_vm._v(" "+_vm._s(_vm.item.content)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }